import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";

const _base = "statistics/";

//  获取总的学习概况 - 首页
export const totalProfile = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "totalProfile", {
           data: _params,
           method: "GET",
         });
       };
// 获取我的学习概况（按课程）- 首页点击更多
export const learnProfileList = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "learnProfileList", {
           data: _params,
           method: "GET",
         });
       };


// WEBPACK FOOTER //
// ./src/fetch/api/studyStatic.js